import React from 'react';
import { AlertBar } from './components/AlertBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Scenarios } from './components/Scenarios';
import { ForWho } from './components/ForWho';
import { ProductOffer } from './components/ProductOffer';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MobileStickyCTA } from './components/MobileStickyCTA';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="2wka1mua9h53u">
      <AlertBar data-id="element-1" data-mp="2wip734ny5m5z" />
      <main data-id="element-2" data-mp="2wi5l9cv6edmo">
        <Hero data-id="element-3" data-mp="28u5y0mx2p5cu" />
        <PainPoints data-id="element-4" data-mp="28tw3qn4zwc1c" />
        <Scenarios data-id="element-5" data-mp="28t4m6g88geu2" />
        <ForWho data-id="element-6" data-mp="28sl3uyeo7ofi" />
        <ProductOffer data-id="element-7" data-mp="28s2y9b64bxux" />
        <Bonuses data-id="element-8" data-mp="23vkuadim43jn" />
        <Testimonials data-id="element-9" data-mp="23w4ey1znd61d" />
        <Guarantee data-id="element-10" data-mp="23utcq6luo6cd" />
        <Faq data-id="element-11" data-mp="23t8iki3g6pf1" />
        <FinalCTA data-id="element-12" data-mp="23ti5fwt74ggi" />
      </main>
      <Footer data-id="element-13" data-mp="3ikr0s4yore8d" />
      <MobileStickyCTA data-id="element-14" data-mp="3iiwasc8k4vxf" />
      <div className="h-20 lg:hidden" aria-hidden="true" data-id="element-15" data-mp="3ijpcuzwkmx98" />
    </div>;
}